import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, renderList as _renderList, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3445ae30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-profile-page content-container" }
const _hoisted_2 = { class: "edit-profile-page__avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/delete-avatar-icon.svg",
  alt: "Delete"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "edit-profile-page__username" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "edit-profile-page__button-left" }
const _hoisted_9 = { class: "edit-profile-page__button-icon" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "edit-profile-page__button-arrow"
}
const _hoisted_12 = { class: "modal-text" }
const _hoisted_13 = { class: "modal-container" }
const _hoisted_14 = {
  key: 0,
  class: "modal__input"
}

import { computed, reactive } from 'vue';
import { IonPage, IonContent, IonIcon } from '@ionic/vue';
import TheHeader from '@/components/TheHeader.vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseInput from '@/components/BaseInput.vue';
import { useUserStore } from '@/stores/user';
import {
  lockClosedOutline,
  mailOutline,
  chevronForwardOutline,
  personOutline,
  globeOutline,
} from 'ionicons/icons';
import { useRouter } from 'vue-router';
import api from '@/api';
import { logEvent } from '@/services/analytics';
import { Capacitor } from '@capacitor/core';
import { Camera } from '@capacitor/camera';
import { getFirebaseStorageResizedAvatar } from '@/services/methods';
import { useInternalization } from '@/composables/useInternalization';
import { SourceLang } from '@/types';

interface menuButtonI {
  name: string;
  icon?: string;
  image?: string;
  handler: () => void;
  isHideArrow?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfilePage',
  setup(__props) {

const userStore = useUserStore();
const user = computed(() => userStore.user);
const router = useRouter();
const { t, setLocale } = useInternalization();

const state = reactive({
  modalsVisibility: {
    deletePhotoConfirmation: false,
    logoutConfirmation: false,
    deleteAccountConfirmation: false,
    language: false,
  },
  password: '',
  loadingMap: {
    deleteAccount: false,
  },
});

const avatarName = computed(
  () => user.value?.alias[0] + user.value?.alias[1] || ''
);
const buttons = computed(() => {
  const buttonsArr = [
    {
      name: t('editPhoto'),
      image: 'image-icon.svg',
      handler: editPhoto,
    },
    {
      name: t('changeName'),
      image: 'pencil-icon.svg',
      handler: () => router.push({ name: 'ChangeName' }),
    },
    {
      name: t('changeLanguage'),
      icon: globeOutline,
      handler: handleChangeLocaleClick,
    },
    {
      name: t('changePassword'),
      icon: lockClosedOutline,
      handler: () => router.push({ name: 'ChangePassword' }),
    },
    {
      name: t('changeEmail'),
      icon: mailOutline,
      handler: () => router.push({ name: 'ChangeEmail' }),
    },
    {
      name: t('logout'),
      image: 'exit-icon.svg',
      handler: () => (state.modalsVisibility.logoutConfirmation = true),
      isHideArrow: true,
    },
    {
      name: t('deleteAccount'),
      image: 'trash-icon.svg',
      handler: () => openDeleteConfirmationModal(),
      isHideArrow: true,
    },
  ] as menuButtonI[];
  if (user.value.isSpecialist) {
    buttonsArr.unshift({
      name: t('aboutMe'),
      icon: personOutline,
      handler: () => router.push({ name: 'AboutMe' }),
    });
  }
  return buttonsArr.filter((b) => {
    if (
      (user.value.authMethod !== 'password' &&
        b.name === t('changePassword')) ||
      (user.value.authMethod !== 'password' && b.name === t('changeEmail'))
    ) {
      return false;
    }
    return true;
  });
});

const backButtonRoutePath = computed(() => {
  return !router.options.history.state.back ? { name: 'MyProfile' } : null;
});

logEvent('view_edit_profile');

function handleChangeLocaleClick() {
  router.push({ name: 'EditProfileChangeLanguage' });
}

async function editPhoto() {
  if (Capacitor.isNativePlatform()) {
    const permissions = await Camera.checkPermissions();
    if (permissions.photos !== 'granted') {
      const { photos } = await Camera.requestPermissions({
        permissions: ['photos'],
      });
      if (photos !== 'granted') {
        return false;
      }
    }
  }

  const image = await Camera.pickImages({
    quality: 60,
    limit: 1,
  });

  await api.users.uploadPhotoByUrl(image.photos[0].webPath);
}

function deletePhoto() {
  state.modalsVisibility.deletePhotoConfirmation = false;
  api.users.deletePhoto();
}

function openDeleteConfirmationModal() {
  state.password = '';
  state.modalsVisibility.deleteAccountConfirmation = true;
}
function closeDeleteConfirmationModal() {
  state.modalsVisibility.deleteAccountConfirmation = false;
}

async function handleDeleteAccount() {
  try {
    state.loadingMap.deleteAccount = true;
    console.log('user.value.authMethod', user.value.authMethod);
    if (user.value.authMethod === 'password') {
      await api.auth.signInWithEmailAndPassword(
        user.value.email,
        state.password
      );
    } else if (user.value.authMethod === 'apple') {
      await api.auth.signInWithApple();
    } else if (user.value.authMethod === 'google') {
      await api.auth.signInWithGoogle();
    }

    await api.auth.deleteMyAccount();
    userStore.unsetUser();
    closeDeleteConfirmationModal();
    router.push({ name: 'Feed' });
    state.loadingMap.deleteAccount = false;
  } catch (e) {
    console.log(e);
    state.loadingMap.deleteAccount = false;
  }
}

async function logout() {
  state.modalsVisibility.logoutConfirmation = false;
  await api.auth.logout();
  await userStore.unsetUser();
  setLocale(userStore.user.language! as SourceLang);
  router.push({ name: 'Feed' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(TheHeader, {
            title: _unref(t)('editProfile'),
            to: backButtonRoutePath.value,
            "show-avatar": false
          }, null, 8, ["title", "to"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (user.value?.avatarUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "edit-profile-page__avatar-img",
                    src: _unref(getFirebaseStorageResizedAvatar)(user.value.avatarUrl, 'profile'),
                    alt: ""
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(avatarName.value), 1)
                  ], 64)),
              (user.value?.avatarUrl)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "edit-profile-page__delete-avatar",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (state.modalsVisibility.deletePhotoConfirmation = true))
                  }, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(user.value.alias), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttons.value, (button, bK) => {
              return (_openBlock(), _createElementBlock("button", {
                key: bK,
                type: "button",
                class: "edit-profile-page__button",
                onClick: ($event: any) => (button.handler())
              }, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    (button.icon)
                      ? (_openBlock(), _createBlock(_unref(IonIcon), {
                          key: 0,
                          icon: button.icon
                        }, null, 8, ["icon"]))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: `/assets/icon/${button.image}`,
                          alt: ""
                        }, null, 8, _hoisted_10))
                  ]),
                  _createElementVNode("span", null, _toDisplayString(button.name), 1)
                ]),
                (!button.isHideArrow)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createVNode(_unref(IonIcon), { icon: _unref(chevronForwardOutline) }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_7))
            }), 128))
          ]),
          _createVNode(BaseModal, {
            title: _unref(t)('modals.deletePhotoTitle'),
            "is-opened": state.modalsVisibility.deletePhotoConfirmation,
            class: "confirm-modal",
            onClose: _cache[2] || (_cache[2] = ($event: any) => (state.modalsVisibility.deletePhotoConfirmation = false))
          }, {
            default: _withCtx(() => [
              _createVNode(BaseButton, {
                class: "modal__btn",
                onClick: deletePhoto
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('yes')), 1)
                ]),
                _: 1
              }),
              _createVNode(BaseButton, {
                white: "",
                class: "modal__btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (state.modalsVisibility.deletePhotoConfirmation = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('no')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title", "is-opened"]),
          _createVNode(BaseModal, {
            title: _unref(t)('modals.logoutTitle'),
            "is-opened": state.modalsVisibility.logoutConfirmation,
            class: "confirm-modal",
            onClose: _cache[4] || (_cache[4] = ($event: any) => (state.modalsVisibility.logoutConfirmation = false))
          }, {
            default: _withCtx(() => [
              _createVNode(BaseButton, {
                class: "modal__btn",
                onClick: logout
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('yes')), 1)
                ]),
                _: 1
              }),
              _createVNode(BaseButton, {
                white: "",
                class: "modal__btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (state.modalsVisibility.logoutConfirmation = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('no')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title", "is-opened"]),
          _createVNode(BaseModal, {
            title: _unref(t)('modals.deleteAccountTitle'),
            "is-opened": state.modalsVisibility.deleteAccountConfirmation,
            class: "delete-account-modal",
            onClose: closeDeleteConfirmationModal
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('modals.deleteAccountText')), 1),
              _createElementVNode("div", _hoisted_13, [
                (user.value.authMethod === 'password')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(BaseInput, {
                        modelValue: state.password,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.password) = $event)),
                        type: "password",
                        placeholder: "Password"
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(BaseButton, {
                  onClick: handleDeleteAccount,
                  loading: state.loadingMap.deleteAccount,
                  class: "modal__btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('confirm')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(BaseButton, {
                  onClick: closeDeleteConfirmationModal,
                  secondary: "",
                  class: "modal__btn",
                  disabled: state.loadingMap.deleteAccount
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["title", "is-opened"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})